/**
 * @module app/actions
 */
import {canContact} from './enablers';
import {helpUrl} from '@netx/core/lib/netx-enablers';

/** @type {array} */
export default [
	/** @action */
	{
		event: 'app:back',
		label: i18n.t('i18n.goBack'),
	},
	/** @action */
	{
		event: 'app:contact',
		label: i18n.t('i18n.contact'),
		enableTest: canContact,
	},
	/** @action */
	{
		event: 'app:help',
		label: i18n.t('i18n.help'),
		enableTest: helpUrl,
	},
	/** @action */
	{
		event: 'app:reportProblem',
		label: i18n.t('i18n.reportProblem'),
	},
	/** @action */
	{
		event: 'app:logout',
		label: i18n.t('i18n.logout'),
	},
	/** @action */
	{
		event: 'app:showOptions',
		label: i18n.t('i18n.options'),
		wrapper(view, e) {
			return [view.model.get('menu')];
		},
	},
];
